import React from 'react';
import { Radio } from 'antd';
import AnswerCard from '../AnswerCard';
import AnswerType from '../AnswerType';
import { injectIntl } from 'react-intl';
const radioStyle = {
	display: 'inline-block',
	height: '30px',
	lineHeight: '30px',
};

function AnswerRadioButton(props) {
	const RadioGroup = Radio.Group;
	const { answers, onVariantChanged, value, onOptionsChanged, questionId, questions, messages, intl: { formatMessage } } = props;
	if (!questions || !questionId) return null;
	
	const onChange = ({ target: { value } }) => onVariantChanged(value);
	const question = questions[questionId];
	const title = `survey.question.${questionId}`;
	return <AnswerCard title={formatMessage(messages[title])} {...props}>
		<RadioGroup value={value} onChange={onChange}>{question.answers.map(id => {
			let { title, ...v } = answers[id];
			title = `survey.answers.${id}`;
			return (<div key={id}>
				<Radio style={{ ...radioStyle }} value={id}>{formatMessage(messages[title])}</Radio>
				<AnswerType
					value={value}
				    onChange={onOptionsChanged}
				    selected={value === id} {...v}
				/>
			</div>);
		})}
		</RadioGroup>
	</AnswerCard>;
}

export default injectIntl(AnswerRadioButton);


// WEBPACK FOOTER //
// ./src/components/AnswerRadioButton/AnswerRadioButton.js